export const cliente = (state) => state.cliente
export const equipo = (state) => state.equipo
export const boleta = (state) => state.boleta
export const fechaCompraEquipo = (state) => state.fechaCompraEquipo
export const extension = (state) => state.extension
export const protecciones = (state) => state.protecciones
// OVG03.2 — Cupón de descuento (SILL-1523)
export const cupon = (state) => state.cupon
export const cuponLoading = (state) => state.cuponLoading
export const cuponError = (state) => state.cuponError
export const tieneCupon = (state) => state.cupon !== null
/** Calcula el monto de descuento sobre el total dado. */
export const montoCupon = (state) => (total) => {
  if (!state.cupon) return 0
  return Math.round((total * state.cupon.porcentaje_descuento) / 100)
}
